<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { SortDirection } from '#layers/base/public';

const { showToggle = true } = defineProps<{
	showToggle?: boolean;
}>();

const direction = defineModel<SortDirection>('direction', { required: true });

const { t } = useI18n();

const directionLabel = computed(() =>
	direction.value === SortDirection.Ascending ? t('common.sort_ascending') : t('common.sort_descending'),
);

function toggleDirection() {
	direction.value = direction.value === SortDirection.Descending ? SortDirection.Ascending : SortDirection.Descending;
}
</script>

<template>
	<DFormField :label="$t('common.sorting')">
		<DFieldGroup>
			<slot name="field-select" />
			<DTooltip
				v-if="showToggle"
				:text="directionLabel"
			>
				<DButton
					size="sm"
					variant="outline"
					color="neutral"
					icon="material-symbols:sort-rounded"
					class="px-2"
					:ui="{ leadingIcon: direction === SortDirection.Descending ? '' : '-scale-y-100' }"
					:aria-label="directionLabel"
					@click="toggleDirection"
				/>
			</DTooltip>
		</DFieldGroup>
	</DFormField>
</template>
